import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { MediaItem } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { StyledPreviewNAWording } from 'components/visualization/MediaCard/index.css'
import { setAutoId, AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

export const Container = styled.div.attrs(() => setAutoId(AutomationId.photoConcept.card))<{
  mode: Theme
}>`
  background: ${({ mode }) => sys[mode].elevation[200].background};
  box-shadow: ${({ mode }) => sys[mode].elevation[200].boxShadow};
  width: 160px;
  height: 160px;
  border-radius: 2px;
  overflow: hidden;
`

interface CardProps {
  url?: string
  onClick?: () => void
  topLeftIcon?: React.ReactNode
}

const Card = ({ url, onClick, topLeftIcon }: CardProps) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  return (
    <Container mode={theme}>
      <MediaItem
        mode={theme}
        width="160px"
        height="160px"
        backgroundColor="transparent"
        previewNaUrl="https://help.quid.com/articles/8240236#h_24b221c46b"
        previewNaUrlWording={
          <StyledPreviewNAWording mode={theme}>{t('moreThreeDot')}</StyledPreviewNAWording>
        }
        previewNaWording={
          <StyledPreviewNAWording
            mode={theme}
            {...{ [AUTO_ATTR_KEY]: AutomationId.photoConcept.previewNotAvailable }}>
            {t('previewUnavailable')}
          </StyledPreviewNAWording>
        }
        data={{
          mediaType: 'Image',
          mediaUrl: url
        }}
        onClick={onClick}
        topLeftIcon={topLeftIcon}
      />
    </Container>
  )
}

export default Card
